import { Helmet } from 'react-helmet';
import {
    Box, Button, Card, CardHeader, CardActions, CardContent, Chip,
    Container, Divider, Link,
    Grid, Typography,
} from '@mui/material';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect } from "react";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { makeStyles, styled } from "@mui/styles";
import { ReactComponent as CrossIcon } from "../../assets/images/corss.svg";
import { ReactComponent as SaveIcon } from "../../assets/images/iconsave.svg";
import { ReactComponent as PenIcon } from "../../assets/images/iconknow.svg";
import { ReactComponent as ListIcon } from "../../assets/images/list.svg";
import planningService from "../../services/planning.service";
import emtyData from "../../assets/images/emty-data.png";

const styles = {
    path: {
        color: "#68717A",
    },
    icon: {
        color: "#6B6B6B",
        marginBottom: "-3px",
        marginRight: "10px",
    },
    link: {
        color: "#5DA196",
        cursor: "pointer",
    },
    end: {
        color: "#A3A3A3",
    },
};

const MainPlaning = () => {
    const { t } = useTranslation();

    useEffect(() => {
        handleGetList()
    }, []);

    const useStyles = makeStyles({
        iconContainer: {
            '& svg': {
                width: "45px",
                height: "45px"
            }
        },
        statusBadge: {
            maxWidth: "150px",
            borderRadius: "5px",
            padding: "5px 12px",
            margin: "0",
        },
        processBgYellow: {
            background: "#EFB76D26",
        },
        processTextYellow: {
            color: "#EFB76D",
        },
        processBgOrange: {
            background: "#F2802626",
        },
        processTextOrange: {
            color: "#F28026",
        },
        processBgGreen: {
            background: "#5DA19626",
        },
        processTextGreen: {
            color: "#5DA196",
        },
        processBgRed: {
            background: "#CC605826",
        },
        processTextRed: {
            color: "#CC6058",
        },
        processBgGrary: {
            background: "#82828226",
        },
        processTextGrary: {
            color: "#828282",
        },
    })
    const navigate = useNavigate();
    const clickLink = (data) => {
        navigate(data, { replace: false });
    }
    const classes = useStyles();
    const vBoxPadding = 2;
    const [List, setList] = React.useState([]);
    const handleGetList = () => {
        planningService.mainPlanning().then(
            (response) => {
                setList(response.data)
            },
        ).catch(() => {

        })
    };
    const handleGoToDetail = (e) => {
        // if (e.target.id !== "prevent" && e.target.parentNode.id !== "prevent" && e.target.parentNode.nodeName !== "g") {
        navigate(`/app/planning/${e}`, { replace: false });
        // }
    }
    const formatData = (data, defaults) => {
        if (data !== null && data !== undefined && data !== "") {
            return data;
        }
        return defaults;
    }

    return (
        <>
            <Helmet>
                <title>HOME | PMS </title>
            </Helmet>
            <Box
                sx={{
                    backgroundColor: 'background.default',
                    minHeight: '100%',
                    py: 3
                }}
            >
                <Container maxWidth="xl">
                    <Grid container pt={2} pb={2}>
                        <Typography fontSize={16} lineHeight={1} color="#68717A"><span style={styles.link} onClick={() => clickLink('/kpi/home')}>{t('label.home')}</span> / <span style={styles.end} >ข้อตกลงภาระงานทางวิชาการ</span></Typography>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={12} >
                            <Typography variant="h1" fontSize={36} lineHeight="53.82px" fontWeight="500">
                                ข้อตกลงภาระงาน
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} pt={2}>
                        {List.length > 0 ?
                            List.map(item => (
                                <Grid item xs={12} >
                                    <Typography variant="h1" fontSize={24} lineHeight="24px" fontWeight="500">
                                        {formatData(item?.description, "-")}
                                    </Typography>
                                    <Grid container spacing={2} pt={3} pl={3}>
                                        <Grid item xs={12} display="flex">
                                            <Grid container xs={4}>
                                                <Grid item sx={{ maxWidth: "420px", width: "100%", cursor: "pointer" }} onClick={() => handleGoToDetail(item.serial)}>
                                                    <Card sx={{ height: 1, paddingTop: "14px", borderRadius: "10px" }}>
                                                        <CardContent>
                                                            <Grid item display="flex" textAlign="left" justifyContent="center" xs={12}>
                                                                <Grid item xs={2}>
                                                                    {/* <div className={`${classes.iconContainer}`}> */}
                                                                    {item?.step === 1 ?
                                                                        <ListIcon /> :
                                                                        item?.step === 2 ?
                                                                            <SaveIcon /> : <PenIcon />
                                                                    }
                                                                    {/* </div> */}
                                                                </Grid>
                                                                <Grid item display="flex" flexDirection="column" xs={9} sx={{ paddingTop: "5px" }}>
                                                                    <Typography fontSize={18} lineHeight="24px" fontWeight={300}>{formatData(item?.description_th, "-")}</Typography>
                                                                    <Box textAlign="center" sx={{ paddingTop: "20px" }}>
                                                                        <Box
                                                                            className={`${classes.statusBadge}  
                                                                    ${item?.status === "draft" ?
                                                                                    classes.processBgYellow
                                                                                    : item?.status === "pending" || item?.status === "pending_cancel" ?
                                                                                        classes.processBgOrange
                                                                                        : item?.status === "approved" ?
                                                                                            classes.processBgGreen
                                                                                            : item?.status === "cancel_cancel" || item?.status === "cancel" ?
                                                                                                classes.processBgGrary : classes.processBgRed}`}
                                                                        >
                                                                            <Typography
                                                                                className={
                                                                                    item?.status === "draft" ?
                                                                                        classes.processTextYellow
                                                                                        : item?.status === "pending" || item?.status === "pending_cancel" ?
                                                                                            classes.processTextOrange
                                                                                            : item?.status === "approved" ?
                                                                                                classes.processTextGreen
                                                                                                : item?.status === "cancel_cancel" || item?.status === "cancel" ?
                                                                                                    classes.processTextGrary : classes.processTextRed}
                                                                                fontSize={14}
                                                                                fontWeight="500"
                                                                            >
                                                                                {formatData(item?.status_description, "-")}
                                                                            </Typography>
                                                                        </Box>
                                                                    </Box>
                                                                </Grid>
                                                                <Grid item xs={1} sx={{ paddingTop: "5px" }}>
                                                                    <Box flex={1} sx={{ borderRadius: "50%", border: "1px solid #DADADA", display: "flex", alignItems: "center", justifyContent: "center", width: "27.95px", height: "27.95px" }}>
                                                                        <CrossIcon />
                                                                    </Box>
                                                                </Grid>
                                                            </Grid>
                                                        </CardContent>
                                                    </Card>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            ))
                            : <Grid container mt={10} spacing={2}>
                                <Grid item xs sm md display="flex" flexDirection="column" alignItems="center">
                                    <Box>
                                        <img src={emtyData} alt="emty-data" />
                                    </Box>
                                    <Box pt={2}>
                                        <Typography variant="h1" fontSize={14} lineHeight="21px" fontWeight="300" color="#939393">
                                            คุณยังไม่มี ข้อตกลงภาระงาน
                                        </Typography>
                                    </Box>
                                </Grid>
                            </Grid>
                        }
                    </Grid>
                </Container>
            </Box>
        </>
    )
};
export default MainPlaning;
